<script>
import { defineComponent } from '@vue/composition-api'
import { EmployeeSearchDTO, EmployeeServiceProxy } from '@/service-proxies/app-v2/employee.service-proxies'
import { WarningServiceProxy, MaintainPlanServiceProxy, MaintainRecordServiceProxy} from '@/service-proxies/app-v2/tpm.service-proxies'
import EditModal from './components/EditModal'
import { dayjsFormat } from '@/utils'

const mrsp = new MaintainRecordServiceProxy()
const esp = new EmployeeServiceProxy()
const wsp = new WarningServiceProxy()
const mpsp = new MaintainPlanServiceProxy()
const columns = [
  { title: 'actions', ellipsis: true, scopedSlots: { customRender: 'action' }, width: 100 },
  { title: 'page_plan_maintenance_application_No', ellipsis: true, dataIndex: 'code', width: 150 },
  { title: 'page_plan_maintenance_equipment_coding', ellipsis: true, dataIndex: 'deviceCode', width: 150 },
  { title: 'page_plan_maintenance_equipment_name', ellipsis: true, dataIndex: 'deviceName', width: 150 },
  { title: 'page_plan_maintenance_equipment_type', ellipsis: true, dataIndex: 'deviceTypeName', width: 150 },
  { title: 'page_plan_maintenance_program', ellipsis: true, dataIndex: 'projectName', width: 150 },
  {
    title: 'page_plan_maintenance_last_maintenance_date',
    dataIndex: 'preMaintainTime',
    ellipsis: true,
    customRender: time => time ? dayjsFormat(time) : "",
    width: 150
  },
  { title: 'page_plan_maintenance_period', ellipsis: true, dataIndex: 'intervalTime', width: 150 },
  {
    title: 'page_plan_maintenance_next_maintenance_date',
    dataIndex: 'maintainDate',
    ellipsis: true,
    width: 150,
    customRender: time => time ? dayjsFormat(time) : "",
  },
]
export default defineComponent({
  components: {
    EditModal
  },
  data(){
    return {
      pagination: {
        current: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      editVisible: false,
      employeesList: [],
      editData: {}
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  created(){
    this.pagination.current = 1
    this.pagination.pageSize = 10
    esp.getPageEmployees(1,{statusList: [1]},"",999999).then(res =>{
      this.employeesList = res.records
    })
    this.getData()
  },
  methods:{
    getData(){
      this.loading = true
      this.dataSource = []
      wsp.pageMaintainPlanToday(this.pagination.current,this.pagination.pageSize).then(res =>{
        this.dataSource = res.records
        this.total = res.total
        this.loading = false
      }).catch(() =>{
        this.loading = false
      })
    },
    openEditModal(records){
      this.editData = records
      this.editVisible = true
    },
    close(){
      this.editVisible = false
    },
    reload(){
      this.editVisible = false
      this.pagination.current = 1
      this.pagination.pageSize = 10
      this.getData()
    },
    showTotal(total) {
      return (this.$t('Total…items')).replace('{0}', total)
    },
    addModal(value){
      mpsp.performMaintainPlan(value.id).then(() => {
        this.$message.success(this.$t('page_plan_maintenance_successful_execution'))
        this.pagination.current = 1
        this.getData()
      })
    },
    handleTableChange(current,size){
      this.pagination.current = current
      this.getData()
    }
  },
})
</script>

<template>
  <div style="position: relative;padding-bottom: 40px;">
    <ml-table bordered :data-source="dataSource" :columns="columns" :scroll="{x: 1300}">
      <template #action="value,records">
        <a v-if="records.planStatus == 2" @click="addModal(records)">{{ $t('page_plan_maintenance_edit_execution') }}</a>
        <a v-if="records.planStatus == 3" @click="openEditModal(records)">{{ $t('page_maintenance_warning_new_records') }}</a>
      </template>
    </ml-table>
    <a-pagination
      style="position:absolute;bottom: 4px;right: 20px"
      :show-total="total => `${showTotal(total)}`"
      :current="pagination.current"
      :pageSize="pagination.pageSize"
      :total="total"
      @change="handleTableChange"
    />
    <edit-modal
      :visible="editVisible"
      :employeesList="employeesList"
      :data="editData"
      @close="close()"
      @reload="reload()"
    ></edit-modal>
  </div>
</template>

